import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import locale from "@bonliva-crm/locale";
import { BookingProfileLocation, useNavigation } from "@navigation";
import { ErrorCard, Spinner, TabBadge } from "@components";
import { Form, FormxDebugger } from "@components/formx";
import { TabFormLayout } from "@components/forms/TabFormLayout";
import BookingEditForm from "./BookingEditForm";
import { BookingEditStore } from "./BookingEditStore";
import { FormData } from "./utils";

type Props = {
  id?: string;
  initialValues?: Partial<FormData>;
  duplicateFrom?: string;
};

export const BookingEdit = (p: Props) => {
  const { navigate, close } = useNavigation();

  const onCloseEdit = (id?: string) => {
    if (id) {
      navigate(new BookingProfileLocation(id));
    } else {
      close();
    }
  };

  const store = useLocalStore(
    () => new BookingEditStore(onCloseEdit, p.id, p.initialValues, p.duplicateFrom)
  );

  return useObserver(() => {
    if (store.loading) {
      return <Spinner fullHeight />;
    }

    if (store.fetchError) {
      return <ErrorCard centered title={store.fetchError} message={store.fetchError} />;
    }

    return (
      <Form allowUpdates store={store}>
        <TabFormLayout
          canSubmit={store.canSubmitForm}
          isDirty={store.dirty}
          isSubmitting={store.isSubmitting}
          onSubmit={store.submit}
          onReset={store.onResetHandler}
          onClose={() => onCloseEdit(p.id)}
          tabs={[
            {
              label: <TabBadge label={locale.Main} hasErrors={false} />,
              value: "main",
              content: <BookingEditForm store={store} />
            }
          ]}
          blockId="BookingEdit"
        >
          <FormxDebugger store={store} />
        </TabFormLayout>
      </Form>
    );
  });
};
